import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Wrapper } from './styles';
import { PageHero, ShippingForm } from '../../components';
import { useUserContext } from '../../context/user_context';
import { Link, useHistory } from 'react-router-dom';
import { useCartContext } from '../../context/cart_context';
import { useProductsContext } from '../../context/products_context';
import Button from '../../components/Button';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import profile from '../../assets/profile.svg';
import EmptyProfile from '../../assets/EmptyProfile.svg';
import { BsArrowRight } from 'react-icons/bs';
import { BiEditAlt } from 'react-icons/bi';
import AddAddress from './AddAddress';
import axios from 'axios';
function ProfilePage() {
  const {
    currentUser,
    logoutUser,
    updateUserProfileImage,
    updateUserProfileName,
    uploadProfileImage,
    updateUserProfilePassword,
    reauthenticateUser,
    updateUserDetails,
    updateProfile
  } = useUserContext();
  const { clearCart } = useCartContext();
  const { closeSidebar } = useProductsContext();
  const [image, setImage] = useState(currentUser.profileImage);
  const [name, setName] = useState(currentUser.username || 'USER');
  const [exisitingPassword, setExistingPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [isVisibleCurrentPassword, setIsVisibleCurrentPassword] =
    useState(false);
  const [isVisibleNewPassword, setIsVisibleNewPassword] = useState(false);
  const [isVisibleConfirmPassword, setIsVisibleConfirmPassword] =
    useState(false);
  const [isAccountInfoActive, setIsAccountInfoActive] = useState(true);
  const [isAddressActive, setIsAddressActive] = useState(false);
  const [email, setEmail] = useState(currentUser.email);
  const [phoneNumber, setPhonenumber] = useState(currentUser.phoneNumber || "");
  const [address, setAddress] = useState(currentUser?.shipping || [])
  const [isAddAddress, setIsAddAddress] = useState(false)
  const [addressForUpdate, setAddressForUpdate] = useState(null)
  const history = useHistory();

  const handleImage = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImage(URL.createObjectURL(file)); // for preview
    await handleImageUpload(file); // send actual file
  };

  const handleImageUpload = async (file) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('image', file);

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_HOST}/api/upload`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );

    const { success, data } = response.data;
    try {
      const response_2 = await updateUserDetails('profileImage', data.url);
      if (response_2.success) {
        toast.success('Profile image changed successfully');
      } else {
        toast.error(`Error: ${response_2.message}`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // eslint-disable-next-line
      const response_2 = await updateProfile(name, email, phoneNumber);
      if(response_2.success){
        toast.success("Profile updated successfully")
      }
      else{
        if (response_2.message === 'Validation error'){
          return toast.error("email or phonenumber already exist");
        }
      }
      
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
    setLoading(false);
  };
  useEffect(() => {
    if (isAddressActive) {
      const fetchAddress = async () => {
        let res = await axios.get(`${process.env.REACT_APP_BACKEND_HOST}/api/user/address/${currentUser.id}`);
        setAddress(res.data.data)
      }
      fetchAddress()
    }

  }, [isAddressActive])

  useEffect(() => {
    document.title = 'Mukunda jewelery | Profile';
  }, []);

  return (
    <Wrapper>
      <PageHero title='profile' />
      <h1 className='w-full text-lg font-semibold justify-start items-start lg:hidden lg:ml-0 ml-24 mb-4'>
        Settings
      </h1>

      <div
        className='flex flex-col md:flex-row gap-6 w-full xl:w-[80%] lg:w-[85%] '
      >
        <div
          className={`flex flex-col gap-3 ml-0 bg-[#FAFAFA] p-2 md:w-[20%] w-full`}
        >
          <div className='flex gap-3 w-full'>
            <div className='w-full flex flex-col gap-4'>
              <div className='profile-img'>
                <img src={image || EmptyProfile} alt='profile' />
                <label
                  className='btn'
                  htmlFor='profile'
                  style={{ backgroundColor: '#d3a143' }}
                >
                  upload new
                </label>
                <input
                  className='file-input'
                  disabled={loading}
                  type='file'
                  accept='image/*'
                  name='profile'
                  id='profile'
                  onChange={handleImage}
                />
              </div>
              <div
                className={`flex gap-2 w-full text-black ${isAccountInfoActive
                    ? 'bg-[#D3A143] text-white'
                    : 'bg-white text-black'
                  } rounded-md`}
              >
                <p
                  className={`cursor-pointer flex w-full items-center justify-between p-2 rounded-md ${isAccountInfoActive ? 'text-white' : ''
                    }`}
                  onClick={() => {
                    setIsAccountInfoActive(true);
                    setIsAddressActive(false);
                  }}
                >
                  Account info{' '}
                  <span>
                    <BsArrowRight />
                  </span>
                </p>
              </div>
              <div
                className='cursor-pointer flex gap-2 w-full justify-between bg-white text-black rounded-md'
                onClick={() => history.push('/orders')}
              >
                <p className='flex w-full items-center justify-between p-2 rounded-md'>
                  My orders{' '}
                  <span>
                    <BsArrowRight />
                  </span>
                </p>
              </div>
              <div
                className={`cursor-pointer flex justify-between gap-2 w-full text-black ${isAddressActive ? 'bg-[#D3A143]' : 'bg-white'
                  }   rounded-md`}
                onClick={() => {
                  setIsAddressActive(true);
                  setIsAccountInfoActive(false);
                }}
              >
                <p
                  className={`flex w-full items-center justify-between p-2 rounded-md ${isAddressActive ? 'text-white' : ''
                    }`}
                >
                  My address
                  <span>
                    <BsArrowRight />
                  </span>
                </p>
              </div>
              <div
                className='cursor-pointer flex justify-center bg-white text-black rounded-md'
                onClick={() => history.push('/wishlist')}
              >
                <p className='flex w-full items-center justify-between p-2 rounded-md'>
                  My wishlist{' '}
                  <span>
                    <BsArrowRight className='font-semibold' />
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className={` flex-1 flex flex-col gap-3 ml-4 mr-2 ${isAddressActive ? 'md:justify-start' : 'md:justify-center'
            }`}
        >
          {isAccountInfoActive && (
            <>
              <h1 className='font-semibold text-lg'>Account Info</h1>

              <form onSubmit={handleSubmit} className='w-full mr-0 sm:mr-20'>
                <div className='flex gap-3 w-full'>
                  <div className='flex flex-col gap-3 w-full'>
                    <label htmlFor='firstName'>Name</label>
                    <input
                      type='text'
                      name='name'
                      className='form-control border border-[#CCCCCC] bg-white rounded-md'
                      placeholder='First name'
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      id='firstName'
                    />
                  </div>
                </div>
                <div className='flex flex-col gap-3 w-full'>
                  <label htmlFor='email'>Email address</label>
                  <input
                    type='email'
                    name='email'
                    className='form-control border border-[#CCCCCC] bg-white rounded-md p-2'
                    placeholder='Email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    id='email'
                  />
                </div>{' '}
                <div className='flex flex-col gap-3 w-full'>
                  <label htmlFor='phoneNumber'>Phone number</label>
                  <input
                    type='number'
                    name='phoneNumber'
                    className='form-control border border-[#CCCCCC] bg-white rounded-md p-2'
                    placeholder='Phonenumber'
                    value={phoneNumber}
                    onChange={(e) => setPhonenumber(e.target.value)}
                    id='phonenumber'
                  />
                </div>
                {/* <button
                  className='btn link mb-3 w-full'
                  style={{ backgroundColor: '#d3a143' }}
                  onClick={() => {
                    history.push('/update-password');
                  }}
                >
                  Change Password commented for future use
                </button> */}
                <button
                  className='btn link mb-4 w-full'
                  style={{ backgroundColor: '#d3a143' }}
                  onClick={() => {
                    clearCart();
                    logoutUser();
                    closeSidebar();
                    window.location.reload();
                  }}
                >
                  logout
                </button>
                <button
                  disabled={loading}
                  type='submit'
                  className='btn link w-full'
                  style={{ backgroundColor: '#d3a143' }}
                >
                  save
                </button>
              </form>
            </>
          )}
          {isAddressActive && (
            <div className='flex flex-col gap-3'>
              <div className='flex justify-between gap-2 md:justify-start lg:gap-8 w-full'>
                {address?.length > 0 && (
                  <h1 className='font-bold text-md md:text-lg'>
                    {' '}
                    My Addresses
                  </h1>
                )}
                {address?.length <= 0 && (
                  <p>No address found, please add address</p>
                )}
                <button
                  className='bg-[#D3A143] text-white rounded-md p-2 mr-2'
                  onClick={() => {
                    setIsAddAddress(true);
                    setAddressForUpdate(null);
                  }}
                >
                  Add Address
                </button>
              </div>
              {isAddAddress && (
                <AddAddress
                  address={addressForUpdate}
                  setIsAddressActive={setIsAddAddress}
                />
              )}
              {!isAddAddress &&
                address?.length > 0 &&
                address?.map((e) => {
                  return (
                    <div className='flex border p-2 shadow-lg mb-2 md:mr-2 sm:w-full md:w-[75%] lg:w-[70%]'>
                      <div className='flex flex-col gap-3'>
                        <div>{e?.name}</div>
                        <div>{e?.phoneNumber}</div>
                        <div>{e?.address?.line1}</div>
                        <div>{e?.address?.postal_code}</div>
                        <div>{e?.address?.city}</div>
                        <div>{e?.address?.state}</div>
                        <div>{e?.address?.country}</div>
                      </div>
                      <p
                        onClick={() => {
                          setAddressForUpdate(e);
                          setIsAddAddress(true);
                        }}
                        className='font-semibold'
                      >
                        Change address{' '}
                        <span>
                          <BiEditAlt />
                        </span>
                      </p>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  );
}

export default ProfilePage;
